export { addToFolderEventAction } from 'next-flight-server-reference-proxy-loader?id=40e15043d8f947f103d628927ea1c875f900c9ec0f&name=addToFolderEventAction!'